const name = 'user'
export default name
